export default __webpack_public_path__ + "static/media/coin.d6ddf48e.png";